export default "__VITE_ASSET__CMDNomxI__$_?url__"